import React, { useContext, useReducer, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Store } from '../Store';
import { toast } from 'react-toastify';
import { getError } from '../utils';
import axios from 'axios';

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_REQUEST':
      return { ...state, loadingUpdate: true };
    case 'UPDATE_SUCCESS':
      return { ...state, loadingUpdate: false };
    case 'UPDATE_FAIL':
      return { ...state, loadingUpdate: false };

    default:
      return state;
  }
};

export default function ProfileScreen() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;
  const [name, setName] = useState(userInfo.name);
  const [email, setEmail] = useState(userInfo.email);
  const [isGoogle, setIsGoogle] = useState(userInfo.isGoogle);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [{ loadingUpdate }, dispatch] = useReducer(reducer, {
    loadingUpdate: false,
  });
  const isGoogleUser = isGoogle;

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!isGoogleUser && password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    // 1. Dispatch the request to set loadingUpdate to true
    dispatch({ type: 'UPDATE_REQUEST' });

    try {
      const { data } = await axios.put(
        '/api/users/profile',
        {
          name,
          email,
          password: isGoogleUser ? undefined : password,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        },
      );

      dispatch({ type: 'UPDATE_SUCCESS' });
      ctxDispatch({ type: 'USER_SIGNIN', payload: data });
      localStorage.setItem('userInfo', JSON.stringify(data));
      toast.success('User updated successfully');

      // Clear password fields after success
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      dispatch({ type: 'UPDATE_FAIL' });
      toast.error(getError(err));
    }
  };

  return (
    <div className="container small-container">
      <Helmet>
        <title>User Profile</title>
      </Helmet>
      <h1 className="my-3">User Profile</h1>
      <form onSubmit={submitHandler}>
        <Form.Group className="mb-3" controlId="name">
          <Form.Label>Name</Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control type="email" value={email} disabled readOnly />
        </Form.Group>

        {!isGoogleUser && (
          <>
            <Form.Group className="mb-3" controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isGoogleUser} // Disables the input if signed in via Google
                readOnly={isGoogleUser} // Makes the input read-only if signed in via Google
                placeholder={isGoogleUser ? 'Managed by Google' : ''}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="confirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={isGoogleUser} // Disables the input if signed in via Google
                readOnly={isGoogleUser} // Makes the input read-only if signed in via Google
              />
            </Form.Group>
          </>
        )}

        <div className="mb-3">
          <Button type="submit" disabled={loadingUpdate}>
            {loadingUpdate ? 'Updating...' : 'Update'}
          </Button>
        </div>
      </form>
    </div>
  );
}
